import React, { useEffect, useMemo, useRef, useState } from 'react';
import { List, ListItem, Stack, Typography } from '@mui/material';
import TabsLanguage from '../../../components/widgets/TabsLanguage';
import CusTextarea from '../../../components/material-ui/CusTextarea';
import { useTranslation } from 'react-i18next';
import BoxGrayContainer from '../../../components/material-ui/BoxGrayContainer';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import { useAppSelector } from '../../../store';

export default function MailingMessage({
  messageText = {},
  setMessageText,
  disabled,
  currentLang,
  setCurrentLang,
  setIsTestSent
}) {
  const { t } = useTranslation();
  const languages = useAppSelector((state) => state.info.casinoLanguages);

  const currentLanguage = useMemo(() => {
    return languages.find((el) => el.lang == currentLang)?.label || currentLang;
  }, [languages, currentLang]);

  const quillRef = useRef(null);

  useEffect(() => {
    const quill = quillRef.current?.getEditor();

    if (!quill) return;

    const editor = quill.root;

    const handlePaste = (e) => {
      const text = e.clipboardData.getData('text/plain');

      let content;

      try {
        content = JSON.parse(text);
      } catch {
        content = text;
      }

      console.log('p', content, text);

      const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(content);

      if (looksLikeHtml) {
        setMessageText(currentLang, content);
        setIsTestSent(false);
      }
    };

    editor.addEventListener('paste', handlePaste);

    return () => {
      editor.removeEventListener('paste', handlePaste);
    };
  }, []);

  return (
    <Stack direction={'column'} gap={1}>
      <Typography color={'textPrimary'}>{t('Fill out a message for the newsletter')}</Typography>
      <TabsLanguage lang={currentLang} setLang={setCurrentLang} />
      <CusTextarea
        quillRef={quillRef}
        readOnly={disabled}
        isTgMode
        key={'MailingMessage_' + currentLang}
        height={250}
        value={messageText[currentLang] || ''}
        onChange={(value) => {
          setMessageText(currentLang, value);
          setIsTestSent(false);
        }}
      />

      <ShowContainer condition={!disabled}>
        <BoxGrayContainer>
          <Typography fontWeight={600}>{t('A message in English is required.')}</Typography>
          <Typography mt={1.5} color="textSecondary">
            {t('The player will receive a message in the language in the following priority:')}
          </Typography>
          <List sx={{ ml: 1, listStyle: 'decimal', pl: 2 }}>
            <ListItem disablePadding sx={{ display: 'list-item' }}>
              <Typography>{t('In the language used in the Telegram interface.')}</Typography>
            </ListItem>
            <ListItem disablePadding sx={{ display: 'list-item' }}>
              <Typography>{t('In the default language set for the casino.')}</Typography>
            </ListItem>
            <ListItem disablePadding sx={{ display: 'list-item' }}>
              <Typography>{t('In English.')}</Typography>
            </ListItem>
          </List>

          <Typography mt={1.5} color="textSecondary">
            {t(
              'When sending a test message, the recipient will receive a message in the selected language in the tab'
            )}{' '}
            ({currentLanguage})
          </Typography>
        </BoxGrayContainer>
      </ShowContainer>
    </Stack>
  );
}
